// extracted by mini-css-extract-plugin
export var root = "MarkdownBadgeAppStore-module--root--6f3c1";